/** Alert types emitted by the API DashboardConstants::ALERT_TYPE_*. */
export const DASHBOARD_ALERT_TYPES = {
  PERSONAL_INVITE_PENDING: 'PERSONAL_INVITE_PENDING',
  DEADLINE_URGENT: 'DEADLINE_URGENT',
  DEADLINE_PASSED: 'DEADLINE_PASSED',
  TAG_REOPEN_REQUESTED: 'TAG_REOPEN_REQUESTED',
} as const;

export type DashboardAlertType =
  (typeof DASHBOARD_ALERT_TYPES)[keyof typeof DASHBOARD_ALERT_TYPES];

/** Permission/API scope token for nation (tags UI and tag-reopen alerts). */
export const DASHBOARD_SCOPE_NATION = 'NATION';

export const DASHBOARD_PATH_SEGMENTS = {
  TAGS: 'tags',
} as const;
